import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import '../../assets/Styles/NoShowTripCSS/NoShowTripCSS.css';
import {Modal, Col, Row, Container, Button, Form} from 'react-bootstrap';
import APICom from '../../utils/helpers/APICom';

const NOSHOWREQ = (props) => {

    const chkRemoveRef = useRef();
    const alarmStatusRef = useRef();
    const noShowStatusRef = useRef();
    const operatorRef = useRef();
    const internalNotesRef = useRef();
    const chkReturnTripRef = useRef();
    const noshowReasonRef = useRef();
    const noshowCommentRef = useRef();

    const [isComponentLoading, setIsComponentLoading] = useState(true);
    const [NoShowlReqDialog, setNoShowReqDialog] = useState(true);
    const [noShowReasons, setNoShowReasons] = useState([]);
    const [displayNoShowReqAlert, setDisplayNoShowReqAlert] = useState(false);
    const [noShowReqAlert, setNoShowReqAlert] = useState({alertTitle: '', alertMsg:''});
    const [noShowStatusOptions, setNoShowStatusOptions] = useState([ {nsID:1, nsStatus:""}, {nsID:2,nsStatus:"Approved"}, {nsID:3,nsStatus:"Not Approved"}])
    const [nsTripObj, setNSTripObj] = useState({iATSPID: '-1', alarmID:'-1', alarmCode:'',cmbNoShowStaus:'',
    alarmSID:'-1', alarmVehicleID:'',iUserID:'', alarmDevLat:'', alarmDevLong:'', iRefID:'-1', vDisplayName:'', iAppID: '26', vPickUpZone: ''  });
    const [chkReturnTripVisible, setchkReturnTripVisible] = useState(false);
    const [isReturnTripCheckBox, setIsReturnTripChecBox] = useState(false);
    const [chkRemove, setChkRemove] = useState(false);
     // Fetching OARA Alarm Status for Dropdown
    const { OARAAlarmStatusData, ASCSSettingData, NoShowReasonData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const { loginData }  = useSelector((store) => store.login);
     // ASCS Settings
    const[firstInZoneIfNSP, setFirstInZoneIfNSP] = useState('false');
    const[bShowFavorDialog, setShowFavorDialog] = useState('false');
    const[checkInOnStand, setCheckInOnStand] = useState('0');

    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setNoShowReqAlert({...noShowReqAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to approve/not approve no show request.'});
            setDisplayNoShowReqAlert(true);
        }
        else
        {
            const NoShowReasonJSON = (NoShowReasonData[props.GridRowData[0].iSRATSPID] !== undefined)? JSON.parse(NoShowReasonData[props.GridRowData[0].iSRATSPID]): undefined;
            if(NoShowReasonJSON !== undefined){
            const noshowReasonByAffiliate = [];
            noshowReasonByAffiliate.push({"name": "Select reason ...", "id": -1, "description": "" });
            NoShowReasonJSON.map((item) => {
                return noshowReasonByAffiliate.push({"name": item.vTitle, "id": item.iId, "description": item.vDescription });
            });
            if(noshowReasonByAffiliate.length > 0)
            {
                setNoShowReasons(noshowReasonByAffiliate);
            }
            }else{
                setNoShowReqAlert({...noShowReqAlert, alertTitle: 'NoShow Reasons', alertMsg:'Error loading noshow reasons!'});
                setDisplayNoShowReqAlert(true);
                return false;
            }
            if(ASCSSettingData !== null && ASCSSettingData !== undefined)
            {
                if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
                    const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
                    for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                    {
                        if(ascsSettingDataByAffiliate[i]["SubTitle"] === "bShowFavorDialog")
                        {
                            setShowFavorDialog(ascsSettingDataByAffiliate[i]["value"]);
                            break;
                        }
                    }
                }
            }
            if(GlobalASCSData !== null && GlobalASCSData !== undefined)
            {
                for(let i=0; i < GlobalASCSData.length; i++)
                {
                    if(GlobalASCSData[i]["SubTitle"] === "CheckInOnStand")
                    {
                        setCheckInOnStand(GlobalASCSData[i]["value"]);
                    }

                    if(GlobalASCSData[i]["SubTitle"] === "firstinzoneifnsp")
                    {
                        setFirstInZoneIfNSP(GlobalASCSData[i]["value"]);
                    }

                }
            }
            const gData = props.GridRowData[0];
            LoadEditOARAAlarmIndication(gData);
            
        }
    }, []);

    useEffect(() => {
        if(isComponentLoading)
        {
            setIsComponentLoading(false);
            return;
        }

    }, [nsTripObj]);


    const LoadEditOARAAlarmIndication = async (gData) => {
        let OARAAlarmIndicationObj = { iServiceID: gData.ServiceID }
        let response = await APICom.fetchData("", "TripActions/LoadEditOARAAlarmIndication", "post", { "Content-Type": "application/json" }, OARAAlarmIndicationObj, null);
        let result = response.data;
        if(result != "")
        {
            setNSTripObj((prevnsTripObj) => ({
                ...prevnsTripObj,
                iATSPID: result['iSRATSPID'].toString(), alarmID: result['Alarm ID'].toString(), alarmCode:result['Alarm Code'], 
                alarmSID: result['ServiceID'].toString(), alarmVehicleID: result['VehicleID'].toString(), iUserID: loginData.iUserID.toString(), 
                alarmDevLat: result['Device Lat'], alarmDevLong: result['Device Long'], isReturnTrip: result['bReturnTrip'], 
                iRefID: result['iRefID'].toString(), vDisplayName: loginData.vDisplayName, vPickUpZone: ''
              }));
              setChkRemove(true);
              if(result.bReturnTrip)
              {
                  setchkReturnTripVisible(true);
                  setIsReturnTripChecBox(false);
              }else
              {
                setchkReturnTripVisible(false);
                setIsReturnTripChecBox(false);
              }
            setNoShowReqDialog(true);
        }
        else
        {
            setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Trip not available', alertMsg:'Unable to load trip data to perform no show.'});
            setDisplayNoShowReqAlert(true);
        }
        
    }

    const handleSaveAndCloseNoShowReq = (e) => {
        if(noShowStatusRef.current.value <= 1)
        {
            setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Missing value', alertMsg:'Please select no-show status value.'});
            setDisplayNoShowReqAlert(true);
        }
        else if(chkReturnTripVisible && noshowReasonRef.current.value <= 1)
        {
            setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Missing value', alertMsg:'Please select no-show reason.'});
            setDisplayNoShowReqAlert(true);
        }
        else
        {
            nsTripObj["bRemove"] = chkRemoveRef.current.checked.toString();
            nsTripObj["comboBox1"] = alarmStatusRef.current.value;
            nsTripObj["txtOperatorAction"] = operatorRef.current.value;
            nsTripObj["NoShowReasonID"] = (noshowReasonRef.current === undefined) ? "-1": noshowReasonRef.current.value;
            nsTripObj["OtherNoShowComments"] = (noshowCommentRef.current === undefined) ? "": noshowCommentRef.current.value;
            nsTripObj["isReturnTrip"] = chkRemoveRef.current.checked.toString();
            nsTripObj["InternalNotes"] = internalNotesRef.current.value;
            nsTripObj["firstInZoneIfNSP"] = firstInZoneIfNSP;

            console.log(nsTripObj);
            SaveEditOARAAlarmIndication(nsTripObj);
            
        }
        
    }


    const SaveEditOARAAlarmIndication = async(nsTripObj) =>
    {
        let response = await APICom.fetchData("", "TripActions/SaveEditOARAAlarmIndication", "post", { "Content-Type": "application/json" }, nsTripObj, null);
        let result = response.data;
        if(result.NoShowStatus === "Approved")
        {
            if(parseInt(result.ResultingCount) < 1)
            {
                setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Failure', alertMsg:'Request Update As No-Show Failed!'});
                setDisplayNoShowReqAlert(true);
            }
            else if(result.vehicleNumber === "")
            {
                setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Invalid VehicleID', alertMsg:'VehicleID Is Not Valid!'});
                setDisplayNoShowReqAlert(true);
            }
            else
            {
                setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Approved', alertMsg:'Request has been approved.'});
                setDisplayNoShowReqAlert(true);
            }
        }
        else
        {
            setNoShowReqAlert({...noShowReqAlert, alertTitle: 'Not Approved', alertMsg:'Request not approved processed.'});
            setDisplayNoShowReqAlert(true);
        }
       
    }

    const handleNoShowReasonChange = (e) => {
        const iTem = noShowReasons.find((item) => {
            return (item.id === Number(e.target.value)) 
          })
          if(iTem)
            noshowCommentRef.current.value = iTem.description;
    }

    const handleNoShowStatusChange = (e) => {
        if(parseInt(e.currentTarget.value) > 1){
        setNSTripObj((prevnsTripObj) => ({
            ...prevnsTripObj,
            cmbNoShowStaus: e.nativeEvent.target[noShowStatusRef.current.selectedIndex].text
          }));
          noShowStatusRef.current.value = e.currentTarget.value;
        }
    }

    const handleRemoveCheckBox = () => {
        setChkRemove(prevValue => !prevValue);
      }

    const handleReturnTripCheckBox = () => {
        setIsReturnTripChecBox(prevValue => !prevValue);
      }
   
    const handleNoShowReqDialogClose = () => {
        setNoShowReqDialog(false);
        UnMountNoShowReqComponent();
    }

    const handleAlertModalClose = () => {
        setDisplayNoShowReqAlert(false);
        setNoShowReqDialog(false);
        UnMountNoShowReqComponent();
      }

    const UnMountNoShowReqComponent = () => {
        if(props.invokeNoShowReqComponent)
        {
            props.RefreshGridData();
            props.setInvokeNoShowReqComponent(false);
        }
    }

    return(
        <>
        
            { NoShowlReqDialog && <Modal centered show={NoShowlReqDialog}  animation={false} size="lg">
                <Modal.Header className='noshow_dialog_header_bgcolor mb-0' onClick={handleNoShowReqDialogClose} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>
                        Edit OARA Alarm Indication
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    <Container>
                    <Row>
                        <Col xs={6} md={2}>
                        <b>Alarm Status:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Select ref={alarmStatusRef} aria-label="Default select example">
                            {OARAAlarmStatusData.map(({ iStatusID, vStatus }, index) => <option key={iStatusID} value={iStatusID} >{vStatus}</option>)} 
                        </Form.Select>
                        </Col>
                        <Col xs={6} md={3}>
                        <b>{<Form.Check ref={chkRemoveRef} type="checkbox" label="Remove Alarm" id="chkRemove" checked={chkRemove} onChange={handleRemoveCheckBox} className='cancel_dialog_returncheckbox_color'/>}</b>
                        </Col>
                        <Col xs={6} md={3}>
                        &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} md={2}>
                        <b>No Show Status:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Select ref={noShowStatusRef} aria-label="Default select example" style={{"marginTop": "5px"}} onChange={handleNoShowStatusChange}>
                            {noShowStatusOptions.map(({ nsID, nsStatus }, index) => <option key={nsID} value={nsID} >{nsStatus}</option>)} 
                        </Form.Select>
                        </Col>
                        <Col xs={6} md={4}>
                        <b>{chkReturnTripVisible && <Form.Check type="checkbox" label="No-Show with return leg(s)" id="chkReturnTrips" onChange={handleReturnTripCheckBox} checked={isReturnTripCheckBox} ref={chkReturnTripRef} className='cancel_dialog_returncheckbox_color' />}</b>
                        </Col>
                        <Col xs={6} md={2}>
                        &nbsp;
                        </Col>
                    </Row>
                    {chkReturnTripVisible && <Row>
                        <Col xs={6} md={2}>
                        <b>No Show Reason:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Select aria-label="Default select example" onChange={handleNoShowReasonChange} ref={noshowReasonRef} >
                            {noShowReasons.map(({ id, name }, index) => <option key={id} value={id} >{name}</option>)} 
                        </Form.Select>
                        </Col>
                        <Col xs={6} md={2}>
                        <b>Any Comments:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Control ref={noshowCommentRef} as="textarea" rows={2}  style={{'resize':'none'}} />
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={6} md={2}>
                        <b>Operator Action:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Control ref={operatorRef} as="textarea" rows={4} style={{'resize':'none', "marginTop": "5px"}} />
                        </Col>
                        <Col xs={6} md={2}>
                        <b>Internal Notes:</b>
                        </Col>
                        <Col xs={6} md={4}>
                        <Form.Control  ref={internalNotesRef} as="textarea" rows={4} style={{'resize':'none', "marginTop": "5px"}} />
                        </Col>
                    </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='noshow_btn_ok' onClick={handleSaveAndCloseNoShowReq}>
                        Save & Close
                    </Button>
                </Modal.Footer>
            </Modal> }

            { displayNoShowReqAlert && <Modal centered show={displayNoShowReqAlert} onHide={handleAlertModalClose} animation={false}>
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noShowReqAlert.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{noShowReqAlert.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>}
        </>
    );
}

export default NOSHOWREQ;